import { render, staticRenderFns } from "./settingIndex.vue?vue&type=template&id=6a1fac3b&scoped=true"
import script from "./settingIndex.vue?vue&type=script&lang=js"
export * from "./settingIndex.vue?vue&type=script&lang=js"
import style0 from "./settingIndex.vue?vue&type=style&index=0&id=6a1fac3b&prod&lang=scss&scoped=true"
import style1 from "./settingIndex.vue?vue&type=style&index=1&id=6a1fac3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1fac3b",
  null
  
)

export default component.exports